import { inject as service } from '@ember/service';
import { sort } from '@ember/object/computed';
import Controller from '@ember/controller';
import { task } from 'ember-concurrency';
import { isPresent } from '@ember/utils';
import RouterService from '@ember/routing/router-service';
import ApiService from 'cio/services/api';
import ExportModel from 'cio/models/export';

export default class IndexController extends Controller {
  @service api!: ApiService;
  @service router!: RouterService;

  queryParams = ['export_id'];
  export_id: string | null = null;
  exportsSorting = ['createdAt:desc'];

  @sort('model', 'exportsSorting') sortedExports!: [ExportModel];

  download = task({ enqueue: true }, async (id: string) => {
    try {
      let downloadPath = `exports/${id}/download`;
      let response = await this.api.post(downloadPath);
      window.location = response.url;
      // Remove query param to avoid re-download on route re-visit.
      if (isPresent(this.export_id)) {
        this.router.transitionTo({
          queryParams: {
            export_id: null,
          },
        });
      }
    } catch (e) {
      // ignore promise failures
    }
  });
}
